// Vendors
import $ from 'jquery';
import aa from 'search-insights';

// Data
import {
  ENV,
  ALGOLIA_APP_ID,
  ALGOLIA_SEARCH_API_KEY,
  ALGOLIA_INDEX
} from './config';

window.aa = aa('init', {
  appId: ALGOLIA_APP_ID,
  apiKey: ALGOLIA_SEARCH_API_KEY,
  useCookie: true
});
let userToken = '';
aa('getUserToken', null, (err, algoliaUserToken) => {
  userToken = algoliaUserToken;
});

const environment = ENV === 'development' ? 'local' : ENV;
const radioInput = $('input[type="radio"][name^="custom-quantity-"]');

// Listen for changes to any radio button with a name that starts with 'custom-quantity-'
$('input[type="radio"][name^="custom-quantity-"]').on('change', function () {
  updatePrice($(this));
});

const updatePrice = (radioInput) => {
  // Get the value of the selected radio button
  let quantityValue = radioInput.val();
  // Update the WooCommerce quantity input field's value
  $('input.qty').val(quantityValue);
  // get the attr data-price from the selected radio button
  let price = radioInput.attr('data-price');
  // add $ and .00 if there are no decimals, one 0 if there is one decimal, and nothing if there are two decimals
  if (price.indexOf('.') === -1) {
    price = '$' + price + '.00';
  } else if (price.indexOf('.') === price.length - 2) {
    price = '$' + price + '0';
  } else {
    price = '$' + price;
  }

  let html =
    '<span class="woocommerce-Price-amount amount">' + price + '</span>';
  // update woocommerce-Price-amount amount with the price
  $('#price_total').html(html);
};

// toggle quantity buttons based on attribute selection
$('.single-product .variations select').on('change', function () {
  $('.acf-variation').removeClass('active');
  let selectedValue = $(this).val();

  // add class to the div with the data-name that mates the selected value
  $('.acf-variation[name="' + selectedValue + '"]').addClass('active');

  // get the radio button that is checked
  let selectedRadio = $(
    '.acf-variation[name="' +
      selectedValue +
      '"] input[type="radio"][name^="custom-quantity-"]:checked'
  );

  updatePrice(selectedRadio);
});
